<div class="info-panel-for-claimant-user">
  <span
    class="info-panel-for-claimant-user-message"
    [innerHTML]="
      'InfoPanel.ClaimantUserEdit'
        | translate
          : {
              claimantFirstName: claimantFirstName,
              claimantLastName: claimantLastName
            }
    "
  ></span>
  <mat-icon
    svgIcon="small-cancel"
    class="info-panel-for-claimant-user-cancel"
    (click)="closePanel()"
  ></mat-icon>
</div>
